import { BaseModel, attr, hasMany } from "../../lib/itn-ui-kit/data";

export default class UserAllAssignable extends BaseModel {
  static urlPath = "core/dynamic-options/assignable-users/";

  @hasMany("user") user;
  @attr("string") name;
}
